import React, {useState} from 'react';

import {CtaButton, RoundButton} from '@optimaxdev/design-system';
import {formatPrice} from '@optimaxdev/utils';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {StatusType} from 'desktop/types/statusType';
import useSearchParams from 'hooks/useSearchParams/useSearchParams';
import {ShippingMethodType} from 'types/shippingMethodsType';

import {AMAZON_URL_PARAM} from '../../constants/amazon';
import {STEPS} from '../../constants/checkout';
import {saveShippingAddressOnAmazonPayment} from '../../store/reducers/paymentStep/amazonV2/amazonV2';
import {getAllStepsStatuses} from '../../store/selectors/currentStep/currentStep';
import {getSelectedShippingMethod} from '../../store/selectors/shippingMethods/shippingMethods';
import {Collapse} from '../collapse/collapse';
import {DeliveryFormTitle} from '../deliveryFormTitle/deliveryFormTitle';
import {ShippingMethodsConnected} from '../shippingMethods/shippingMethods';

import s from './deliveryStepResumeAmazon.scss';

export type PropsType = {
    stepsStatuses: StatusType;
    selectedShippingMethod?: ShippingMethodType;
    saveShippingMethodV2: () => {};
};

/**
 * Step resume Amazon for checkout
 *
 * @constructor
 */
export const DeliveryStepResumeAmazon: React.FC<PropsType> = ({
    saveShippingMethodV2,
    selectedShippingMethod,
    stepsStatuses,
}) => {
    const [isShippingMethodsOpen, setIsShippingMethodsOpen] = useState(false);
    const {[STEPS.DELIVERY_STEP]: deliveryStep} = stepsStatuses;
    const params = useSearchParams();

    const handleAddressSave = () => {
        saveShippingMethodV2();
        setIsShippingMethodsOpen(false);
    };

    return (
        <div className={s.wrapper}>
            <div className={s.completedStepIcon} />

            <div className={s.rightSideAddressesWrapper}>
                <div className={s.header}>Delivery & Billing</div>
                <div className={s.description}>
                    <b>Login and pay with Amazon</b> - Place an order using your Amazon account
                </div>
                {selectedShippingMethod && deliveryStep.completed && (
                    <div className={s.method}>
                        <div className={s.separator} />
                        <div className={s.content}>
                            <div className={s.description}>
                                <b>Shipping method: </b>
                                {`${selectedShippingMethod.title}, ${
                                    selectedShippingMethod.description
                                }, (${
                                    Number(selectedShippingMethod.price) === 0
                                        ? 'Free'
                                        : formatPrice('$', selectedShippingMethod.price)
                                })`}
                            </div>
                            {params.get(AMAZON_URL_PARAM.PAYMENT_CONFIRMED) !== 'true' && (
                                <RoundButton
                                    className={s.button}
                                    colorName="geyser"
                                    onClick={() => setIsShippingMethodsOpen(!isShippingMethodsOpen)}
                                    size="extraSmall"
                                    isFull
                                >
                                    Change Shipping Method
                                </RoundButton>
                            )}
                        </div>
                    </div>
                )}

                <Collapse isOpen={isShippingMethodsOpen}>
                    <div className={s.shippingMethodsList}>
                        <DeliveryFormTitle>Shipping methods</DeliveryFormTitle>
                        <ShippingMethodsConnected />
                        <CtaButton className={s.continueButton} onClick={handleAddressSave} isFull>
                            Continue
                        </CtaButton>
                    </div>
                </Collapse>
            </div>
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    selectedShippingMethod: getSelectedShippingMethod(store),
    stepsStatuses: getAllStepsStatuses(store),
});

export const StepResumeAmazonConnected = connect(mapStateToProps, {
    saveShippingMethodV2: saveShippingAddressOnAmazonPayment,
})(DeliveryStepResumeAmazon);
